export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const BASE_WEB_SOCKET_URL = process.env.REACT_APP_BASE_WEB_SOCKET_URL;

export const OPEN_API_BASE_URL = process.env.REACT_APP_BASE_OPEN_API_URL;